import { DatePicker } from "@components/index";
import { useFilterContext } from "@pages/Dashboard/contexts/Filter.context";
import { isDateOlderThanLastMonth } from "@src/module/utils/datetime";

import styles from "./DatePickerFilter.module.scss";

const DatePickerFilter: React.FC<React.PropsWithChildren> = () => {
  const {
    date,
    setDate,
  } = useFilterContext();

  const handleChangeDate = (value: Date) =>
    setDate(value);

  return (
    <div className={styles.container}>
      <DatePicker
        oneTap
        id="filter"
        value={date}
        onChange={handleChangeDate}
        format="dd/MM/yyyy"
        cleanable={false}
        shouldDisableDate={isDateOlderThanLastMonth} />
    </div>
  );
};

export default DatePickerFilter;
